import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/forum/app';
const dayjs = window.dayjs;
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import LineupUserScoresModal from './LineupUserScoresModal';
import JokoakNavbar from '../aurrera-jokoak/JokoakNavbar';
import NagusiBackNav from '../common/NagusiBackNav';
import UserMatchLineupWidget from './UserMatchLineupWidget';
import SelectMatchModal from '../aurrera-jokoak/SelectMatchModal';
import JokoakScoringCriteriaCard from '../aurrera-jokoak/JokoakScoringCriteriaCard';
export default class LineupClassificationPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.seasonSlug = m.route.param('season');
    this.userStats = [];
    this.matchList = [];
    this.expandedMatches = {}; // matchId => boolean
    this.matchScores = {}; // matchId => scores[]
    this.matchLoading = {}; // matchId => boolean
    this.sortColumn = 'points';
    this.sortDirection = 'desc';
    this.loadData();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    const currentPath = m.route.get() || '';
    const isVoteMode = currentPath.includes('/pronosticar');
    const currentMode = isVoteMode ? 'vote' : 'classification';
    const currentSeason = m.route.param('season');
    if (this.seasonSlug !== currentSeason || this.loadedMode !== currentMode) {
      this.seasonSlug = currentSeason;
      this.loadData();
    }
  }
  loadData() {
    this.loading = true;
    const currentPath = m.route.get() || '';
    const isVoteMode = currentPath.includes('/pronosticar');
    const currentMode = isVoteMode ? 'vote' : 'classification';
    this.loadedMode = currentMode;
    this.loadedSeason = this.seasonSlug;
    if (isVoteMode) {
      // In vote mode (/pronosticar), we only need upcoming/active matches
      // and lineups for those upcoming matches. No need to load full season classification
      // or 500+ lineups from past completed matches.
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches",
        params: {
          season: this.seasonSlug,
          upcoming: 1,
          include: 'userMatchLineups,userMatchLineups.user,team,rival'
        }
      }).then(matchesResponse => {
        const matches = app.store.pushPayload(matchesResponse) || [];
        this.matchList = matches.sort((a, b) => {
          const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
          const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
          return dateA - dateB;
        });
        this.loading = false;
        m.redraw();
      }).catch(err => {
        this.loading = false;
        this.error = err;
        m.redraw();
      });
    } else {
      // In classification mode (/clasificacion), we need summary scores and the list of matches
      // without serializing hundreds of user lineups for each past match.
      const summaryPromise = app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/lineup-classification",
        params: {
          season: this.seasonSlug,
          summary: 1,
          include: 'user'
        }
      });
      const matchesPromise = app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches",
        params: {
          season: this.seasonSlug,
          include: 'team,rival'
        }
      });
      Promise.all([summaryPromise, matchesPromise]).then(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          summaryResponse = _ref2[0],
          matchesResponse = _ref2[1];
        const scores = app.store.pushPayload(summaryResponse);
        const matches = app.store.pushPayload(matchesResponse) || [];
        this.matchList = matches.sort((a, b) => {
          const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
          const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
          return dateA - dateB;
        });
        this.processSummaryData(scores);
        this.loading = false;
        m.redraw();
      }).catch(err => {
        this.loading = false;
        this.error = err;
        m.redraw();
      });
    }
  }
  processSummaryData(scores) {
    this.userStats = scores.map(score => ({
      user: score.user(),
      points: score.attribute('points'),
      matchCount: score.attribute('matchCount'),
      // We'll load individual scores on demand for the modal if needed
      matchScores: {}
    }));
    this.sortStats();
  }
  sortStats() {
    const column = this.sortColumn;
    const direction = this.sortDirection;
    this.userStats.sort((a, b) => {
      let valA, valB;
      if (column === 'user') {
        valA = username(a.user).toLowerCase();
        valB = username(b.user).toLowerCase();
      } else {
        valA = a[column];
        valB = b[column];
      }
      if (valA < valB) return direction === 'asc' ? -1 : 1;
      if (valA > valB) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  }
  toggleMatch(matchId) {
    if (this.expandedMatches[matchId]) {
      delete this.expandedMatches[matchId];
    } else {
      this.expandedMatches[matchId] = true;
      if (!this.matchScores[matchId]) {
        this.loadMatchScores(matchId);
      }
    }
  }
  loadMatchScores(matchId) {
    this.matchLoading[matchId] = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/lineup-classification",
      params: {
        season: this.seasonSlug,
        match_id: matchId,
        include: 'user'
      }
    }).then(response => {
      const scores = app.store.pushPayload(response);
      this.matchScores[matchId] = scores.sort((a, b) => b.points() - a.points());
      this.matchLoading[matchId] = false;
      m.redraw();
    });
  }
  scrollToUser(userId) {
    let el = document.getElementById("lineup-user-row-".concat(userId));
    if (!el) {
      el = document.getElementById("lineup-podium-user-".concat(userId));
    }
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      el.classList.remove('is-flashing');
      void el.offsetWidth;
      el.classList.add('is-flashing');
      setTimeout(() => {
        if (el) el.classList.remove('is-flashing');
      }, 2600);
    }
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "LineupClassificationPage"
      }, m(LoadingIndicator, null));
    }
    const seasonName = this.seasonSlug.replace('-', '/');
    const currentPath = m.route.get() || '';
    const isVoteMode = currentPath.includes('/pronosticar');
    const isMobile = window.innerWidth < 768;
    const season = this.seasonSlug || '2025-2026';
    const activeLineupMatches = this.matchList.filter(match => {
      const matchDate = match.matchDate();
      if (!matchDate) return false;
      const deadline = dayjs(matchDate).subtract(2, 'hours');
      return dayjs().isBefore(deadline);
    }).sort((a, b) => new Date(a.matchDate()).getTime() - new Date(b.matchDate()).getTime());
    const ranks = [];
    const ties = [];
    let currentRank = 1;
    for (let i = 0; i < this.userStats.length; i++) {
      if (i > 0 && this.userStats[i].points !== this.userStats[i - 1].points) {
        currentRank = i + 1;
      }
      ranks[i] = currentRank;
    }
    for (let i = 0; i < this.userStats.length; i++) {
      const r = ranks[i];
      ties[i] = ranks.filter(x => x === r).length > 1;
    }
    const top3 = this.userStats.slice(0, 3);
    const currentUserId = app.session.user ? app.session.user.id() : null;
    const userRankIndex = currentUserId ? this.userStats.findIndex(stat => stat.user && String(stat.user.id()) === String(currentUserId)) : -1;
    const myRank = userRankIndex !== -1 ? ranks[userRankIndex] : null;
    const myIsTied = userRankIndex !== -1 ? ties[userRankIndex] : false;
    const playedMatches = this.matchList.filter(m => m.getScore() || m.matchDate() && new Date(m.matchDate()).getTime() < Date.now());
    const lastPlayed = playedMatches.length > 0 ? playedMatches[playedMatches.length - 1] : null;
    return m("div", {
      className: "LineupClassificationPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "11 Aldeanos"
    }), m("h2", {
      className: "LineupClassificationPage-Title"
    }, "11 Aldeanos"), m(JokoakNavbar, null), m("div", {
      className: "JokoakSubmenu"
    }, m(Link, {
      href: "/11-aldeanos/".concat(season, "/clasificacion"),
      className: "JokoakSubmenu-link ".concat(!isVoteMode ? 'active' : '')
    }, "\uD83C\uDFC6 Clasificaci\xF3n"), m(Link, {
      href: "/11-aldeanos/".concat(season, "/pronosticar"),
      className: "JokoakSubmenu-link ".concat(isVoteMode ? 'active' : '')
    }, "\u26BD Hacer 11")), isVoteMode ? activeLineupMatches.length > 0 ? m("div", {
      id: "lineup-vote",
      className: "ActiveGameSection BolillaActiveSection",
      style: "margin-bottom: 40px; display: flex; flex-direction: column; gap: 20px;"
    }, m("div", {
      className: "BolillaVoteHeader"
    }, m("h3", null, m("span", {
      style: "font-size: 1.2em;"
    }, "\u26BD"), "Pronosticar Pr\xF3ximos Partidos (", activeLineupMatches.length, ")")), activeLineupMatches.map((match, index) => {
      const isExpanded = this.expandedMatchId === match.id() || this.expandedMatchId === undefined && index === 0;
      const matchDate = match.matchDate();
      const currentUserId = app.session.user ? app.session.user.id() : null;
      const userLineup = currentUserId && (match.userMatchLineups() || []).find(l => {
        const lUid = l.user() ? l.user().id() : typeof l.userId === 'function' ? l.userId() : l.userId;
        return String(lUid) === String(currentUserId);
      });
      return m("div", {
        key: match.id(),
        className: "BolillaMatchCard"
      }, m("div", {
        className: "BolillaMatchCard-header",
        onclick: () => {
          this.expandedMatchId = isExpanded ? null : match.id();
          m.redraw();
        }
      }, m("div", {
        style: "display: flex; align-items: center; gap: 12px;"
      }, m("span", {
        style: "font-size: 1.2em; font-weight: 800; color: #ee2523; background: rgba(238,37,35,0.08); padding: 4px 10px; border-radius: 8px;"
      }, "#", index + 1), m("div", null, m("h4", {
        style: "font-size: 1.2em; font-weight: 800; margin: 0; color: var(--heading-color);"
      }, typeof match.renderName === 'function' ? match.renderName({
        showJornada: true
      }) : match.getName()), matchDate && m("div", {
        style: "font-size: 0.85em; color: var(--muted-color); font-weight: 600; margin-top: 2px;"
      }, m("i", {
        className: "far fa-clock",
        style: "margin-right: 5px;"
      }), dayjs(matchDate).format('D MMMM YYYY, HH:mm'), " h"))), m("div", {
        style: "display: flex; align-items: center; gap: 12px;"
      }, app.session.user && (userLineup ? m("span", {
        style: "font-size: 0.85em; font-weight: 700; color: #10b981; background: rgba(16,185,129,0.12); padding: 5px 12px; border-radius: 20px; border: 1px solid rgba(16,185,129,0.3); display: inline-flex; align-items: center; gap: 6px;"
      }, m("i", {
        className: "fas fa-check-circle"
      }), " Once Creado") : m("span", {
        style: "font-size: 0.85em; font-weight: 700; color: #f59e0b; background: rgba(245,158,11,0.12); padding: 5px 12px; border-radius: 20px; border: 1px solid rgba(245,158,11,0.3); display: inline-flex; align-items: center; gap: 6px;"
      }, m("i", {
        className: "fas fa-clock"
      }), " Pendiente")), m("i", {
        className: "fas fa-chevron-".concat(isExpanded ? 'up' : 'down'),
        style: "color: var(--muted-color); font-size: 1.1em;"
      }))), isExpanded && m("div", {
        className: "BolillaMatchCard-body"
      }, m(UserMatchLineupWidget, {
        match: match,
        key: match.id()
      })));
    })) : m("div", {
      className: "ActiveGameSection BolillaNoActiveGame LineupNoActiveGame"
    }, m("span", {
      style: "font-size: 3em;"
    }, "\uD83D\uDEE1\uFE0F"), m("h3", {
      style: "font-weight: 800; margin-top: 15px;"
    }, "No hay partidos activos"), m("p", {
      style: "margin-bottom: 20px;"
    }, "Todos los partidos ya han comenzado o no hay partidos programados en este momento."), m(Link, {
      href: "/11-aldeanos/".concat(season, "/clasificacion"),
      className: "Button Button--primary",
      style: "border-radius: 20px; font-weight: bold; padding: 8px 24px;"
    }, "\uD83C\uDFC6 Ver Clasificaci\xF3n General")) : m("div", null, m(JokoakScoringCriteriaCard, {
      game: "lineup"
    }), top3.length > 0 && m("div", {
      className: "SeasonOverview"
    }, m("div", {
      className: "Podium"
    }, top3[1] && this.renderPodiumUser(top3[1], ranks[1]), top3[0] && this.renderPodiumUser(top3[0], ranks[0]), top3[2] && this.renderPodiumUser(top3[2], ranks[2]))), m("div", {
      className: "Stats-Main-Content"
    }, m("div", {
      className: "Season-Statistics"
    }, m("div", {
      className: "Top-Players-Full-Table"
    }, m("div", {
      className: "Classification-Header-Actions"
    }, m("h4", null, app.translator.trans('nagusi-match-ratings.forum.classification.table_title')), myRank !== null && m(Button, {
      className: "Button Button--my-position",
      onclick: () => this.scrollToUser(currentUserId),
      icon: "fas fa-crosshairs"
    }, m("span", null, "Mi posici\xF3n (", myRank, "\xBA)"))), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", {
      onclick: () => this.toggleSort('user'),
      className: "sortable"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.user')), m("th", {
      onclick: () => this.toggleSort('points'),
      className: "sortable center"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.points')), m("th", {
      onclick: () => this.toggleSort('matchCount'),
      className: "sortable center"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.matches')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.details')))), m("tbody", null, this.userStats.map((stat, index) => {
      const isCurrent = app.session.user && String(app.session.user.id()) === String(stat.user.id());
      const userUrl = app.route('user', {
        username: stat.user.slug()
      });
      const rank = ranks[index];
      return m("tr", {
        key: stat.user.id(),
        id: "lineup-user-row-".concat(stat.user.id()),
        className: isCurrent ? 'highlight-current-user' : ''
      }, m("td", null, m("div", {
        className: "Player-Table-Info"
      }, m("span", {
        className: "rank-badge-cell"
      }, m("span", {
        className: "rank-badge rank-".concat(rank)
      }, rank, "\xBA")), m(Link, {
        href: userUrl
      }, avatar(stat.user, {
        className: 'Player-Avatar-Tiny'
      })), m(Link, {
        href: userUrl,
        className: "Player-Name"
      }, username(stat.user)), isCurrent && m("span", {
        className: "badge-you"
      }, "T\xDA"))), m("td", {
        className: "center bold"
      }, stat.points), m("td", {
        className: "center"
      }, stat.matchCount), m("td", {
        className: "center"
      }, m(Button, {
        className: "Button Button--link",
        onclick: () => {
          // Load full details for this user before showing modal
          this.showUserDetails(stat);
        },
        icon: "fas fa-info-circle"
      }, m("span", {
        className: "Button-label"
      }, app.translator.trans('nagusi-match-ratings.forum.classification.view_details')))));
    }))))))), m("div", {
      className: "Matches-Classification-List"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; flex-wrap: wrap; gap: 10px;"
    }, m("h4", {
      className: "Section-Title",
      style: "margin: 0;"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.matches_title')), lastPlayed && m(Button, {
      className: "Button Button--secondary",
      onclick: () => {
        const el = document.getElementById("lineup-match-".concat(lastPlayed.id()));
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      },
      style: "border-radius: 20px; font-weight: bold; padding: 6px 14px; font-size: 13px;"
    }, m("i", {
      className: "fas fa-arrow-down",
      style: "margin-right: 6px;"
    }), "Ir al \xFAltimo partido disputado")), m("div", {
      className: "Matches-Grid"
    }, this.matchList.map(match => this.renderMatchItem(match)))))));
  }
  showUserDetails(stat) {
    app.modal.show(LineupUserScoresModal, {
      userStat: stat,
      matches: this.matchList,
      seasonSlug: this.seasonSlug
    });
  }
  renderMatchItem(match) {
    const isExpanded = this.expandedMatches[match.id()];
    const isLoading = this.matchLoading[match.id()];
    const scores = this.matchScores[match.id()] || [];
    const matchDate = match.matchDate() ? dayjs(match.matchDate()).format('DD/MM/YYYY') : '';
    return m("div", {
      className: "MatchRow-Card ".concat(isExpanded ? 'is-expanded' : ''),
      id: "lineup-match-".concat(match.id()),
      key: match.id(),
      style: "background: #fff; border-radius: 12px; margin-bottom: 15px; box-shadow: 0 4px 6px rgba(0,0,0,0.03); border: 1px solid #eee; overflow: hidden;"
    }, m("div", {
      className: "MatchRow-Header",
      onclick: () => this.toggleMatch(match.id())
    }, m("div", {
      className: "MatchRow-Info"
    }, m("div", {
      className: "MatchRow-Title"
    }, match.renderName()), m("div", {
      className: "MatchRow-Meta"
    }, m("span", {
      className: "MatchRow-Date"
    }, m("i", {
      className: "far fa-calendar-alt MatchDate-Icon"
    }), " ", matchDate))), m("div", {
      className: "MatchRow-Toggle"
    }, m("i", {
      className: "fas ".concat(isExpanded ? 'fa-chevron-up' : 'fa-chevron-down')
    }))), isExpanded && m("div", {
      className: "MatchRow-Body",
      style: "padding: 20px; border-top: 1px solid #f0f0f0; background: #fafafa;"
    }, isLoading ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m("div", {
      className: "Match-Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, app.translator.trans('nagusi-match-ratings.forum.classification.user')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.points')))), m("tbody", null, scores.length > 0 ? scores.map((score, index) => {
      const scoreUser = score.user();
      const isCurrent = app.session.user && scoreUser && String(app.session.user.id()) === String(scoreUser.id());
      return m("tr", {
        key: score.id(),
        className: isCurrent ? 'highlight-current-user' : ''
      }, m("td", null, m("div", {
        className: "Player-Table-Info"
      }, avatar(score.user(), {
        className: 'Player-Avatar-Tiny'
      }), m("span", {
        className: "Player-Name"
      }, username(score.user())), isCurrent && m("span", {
        className: "badge-you"
      }, "T\xDA"), index < 3 && m("span", {
        className: "rank-badge rank-".concat(index + 1)
      }, index + 1))), m("td", {
        className: "center bold"
      }, score.points()));
    }) : m("tr", null, m("td", {
      colspan: "2",
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.no_scores'))))))));
  }
  renderPodium() {
    const top3 = this.userStats.slice(0, 3);
    if (top3.length === 0) return null;
    return m("div", {
      className: "SeasonOverview"
    }, m("div", {
      className: "Podium"
    }, top3[1] && this.renderPodiumUser(top3[1], 2), top3[0] && this.renderPodiumUser(top3[0], 1), top3[2] && this.renderPodiumUser(top3[2], 3)));
  }
  renderPodiumUser(stat, position) {
    const isFirst = position === 1;
    const isCurrent = app.session.user && stat.user && String(app.session.user.id()) === String(stat.user.id());
    const userUrl = app.route('user', {
      username: stat.user.slug()
    });
    const pathId = 'txapela-podium-path-' + Math.random().toString(36).substr(2, 9);
    return m("div", {
      id: "lineup-podium-user-".concat(stat.user.id()),
      className: "Podium-Player pos-".concat(position, " ").concat(isFirst ? 'MVP' : '', " ").concat(isCurrent ? 'highlight-current-user' : '')
    }, m(Link, {
      href: userUrl,
      className: "Player-Avatar-Wrapper"
    }, avatar(stat.user), m("div", {
      className: "Rank-Badge"
    }, position), isFirst && m("div", {
      className: "MVP-Txapela"
    }, m("svg", {
      viewBox: "0 0 100 45",
      className: "txapela-svg",
      xmlns: "http://www.w3.org/2000/svg"
    }, m("defs", null, m("path", {
      id: pathId,
      d: "M 8,24 Q 50,13 92,24",
      fill: "none",
      stroke: "none"
    })), m("ellipse", {
      cx: "50",
      cy: "30",
      rx: "35",
      ry: "8",
      fill: "rgba(0, 0, 0, 0.25)"
    }), m("path", {
      d: "M 8,24 C 8,6 92,6 92,24 C 92,36 8,36 8,24 Z",
      fill: "#1e1e1f"
    }), m("path", {
      d: "M 20,28 Q 50,34 80,28 Q 50,23 20,28 Z",
      fill: "#131314"
    }), m("path", {
      d: "M 50,11 Q 50,4 51,2 Q 53,4 53,11 Z",
      fill: "#1e1e1f"
    }), m("text", {
      fill: "#ffffff",
      "font-size": "5",
      "font-weight": "900",
      "letter-spacing": "0.8",
      stroke: "#ffd700",
      "stroke-width": "0.15px",
      dy: "1.5",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, m("textPath", {
      href: "#".concat(pathId),
      startOffset: "50%",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, "TXAPELDUN"))))), m("div", {
      className: "Player-Details"
    }, m(Link, {
      href: userUrl,
      className: "Player-Name"
    }, username(stat.user), isCurrent && m("span", {
      className: "badge-you"
    }, "T\xDA")), m("div", {
      className: "Player-Score-Container"
    }, m("span", {
      className: "Player-Average"
    }, stat.points), m("span", {
      className: "Label"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.points_label')))));
  }
  renderMatchBreakdown() {
    // Removed as per request, logic moved to modal
    return null;
  }
  toggleSort(column) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'desc';
    }
    this.sortStats();
    m.redraw();
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/LineupClassificationPage', LineupClassificationPage);